/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getPendingTasks } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

type GetPendingTasksOptions = {
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetPendingTasks = (data: GetPendingTasksOptions) =>
  useQuery<any>({
    queryKey: userQueryKeys.userPendingTasks,
    queryFn: data.queryFn ? data.queryFn : () => getPendingTasks().then((res) => res.data),
    ...data.options,
  });
